import React, {useState} from 'react'
import {Box, Flex, useStyleConfig, HStack} from '@chakra-ui/react'
import {VerticalLineIcon} from '../icons'
import {FormattedMessage} from 'react-intl'
import CustomLink from '../custom-link'
import {useLocation} from 'react-router-dom'
import PropTypes from 'prop-types'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY} from '../../brand'

const CorporateBenefitBanner = ({onExit}) => {
    const styles = useStyleConfig('SovraHeader')
    const {locale} = useMultiSite()
    const location = useLocation()

    const landingUrl = useState(`/${locale?.alias}` + location.search)
    const isKenwood = BRAND_KEY === 'kenwood'

    return (
        <Flex w="100%" pos="relative" zIndex={1200}>
            <Box {...styles.container} {...styles.containerDesktop} display="flex">
                <HStack {...styles.hstack}>
                    <CustomLink
                        isExternal={false}
                        href={landingUrl}
                        asButton={true}
                        variant="inverse-icon-button"
                        {...styles.label}
                    >
                        {isKenwood ? (
                            <FormattedMessage
                                id="corporate_benefit_banner.title.kenwood"
                                defaultMessage="Discover the Corporate Benefit offer"
                            />
                        ) : (
                            <FormattedMessage
                                id="corporate_benefit_banner.title"
                                defaultMessage="Discover the Corporate Benefit offer"
                            />
                        )}
                    </CustomLink>
                    <Flex align="center" justify="center" flex="1">
                        <VerticalLineIcon {...styles.icon} />
                    </Flex>
                    <CustomLink
                        isExternal={false}
                        onClick={async (e) => {
                            e.preventDefault()
                            if (onExit) {
                                await onExit()
                            }
                        }}
                        asButton={true}
                        variant="inverse-icon-button"
                        {...styles.label}
                    >
                        {isKenwood ? (
                            <FormattedMessage
                                id="corporate_benefit_banner.exit.kenwood"
                                defaultMessage="Exit"
                            />
                        ) : (
                            <FormattedMessage
                                id="corporate_benefit_banner.exit"
                                defaultMessage="Exit"
                            />
                        )}
                    </CustomLink>
                </HStack>
            </Box>
        </Flex>
    )
}

CorporateBenefitBanner.propTypes = {
    onExit: PropTypes.func.isRequired,
}

CorporateBenefitBanner.getTemplateName = () => 'corporate-benefit-banner'

export default CorporateBenefitBanner
